// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionTitle_container__1p1s7","sectionTitle":"SectionTitle_sectionTitle__2rNpy","sectionSubtitle":"SectionTitle_sectionSubtitle__2P_oU"};